<template>
  <div>
    <el-form
      ref="stevedoreForm"
      :model="stevedore"
      :rules="rules"
      @submit.native.prevent
    >
      <el-form-item label="Короткое название" prop="name">
        <el-input
          v-model="stevedore.name"
          placeholder="Укажите короткое название"
        />
      </el-form-item>
      <el-form-item label="Юр. Название" prop="legal_name">
        <el-input
          v-model="stevedore.legal_name"
          placeholder="Укажите юр. название"
        />
      </el-form-item>
      <el-form-item label="Юр. Адрес" prop="legal_address">
        <el-input
          v-model="stevedore.legal_address"
          placeholder="Укажите юр. адрес"
        />
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="center" style="margin-top: 20px">
      <el-button type="primary" @click="saveStevedore">Сохранить</el-button>
    </el-row>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'

const Stevedore = RepositoryFactory.get('stevedores')

export default {
  name: 'NewStevedore',
  props: {
    obj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      stevedore: {
        name: '',
        legal_name: '',
        legal_address: '',
      },
      rules: {
        name: {
          required: true,
          message: 'Укажите короткое название',
          trigger: 'blur',
        },
        legal_name: {
          required: true,
          message: 'Укажите юр. название',
          trigger: 'blur',
        },
        legal_address: {
          required: true,
          message: 'Укажите юр. адрес',
          trigger: 'blur',
        },
      },
    }
  },
  watch: {
    obj: {
      immediate: true,
      handler(newVal) {
        this.stevedore.name = newVal ? newVal.name : ''
        this.stevedore.legal_name = newVal ? newVal.legal_name : ''
        this.stevedore.legal_address = newVal ? newVal.legal_address : ''
      },
    },
  },
  methods: {
    saveStevedore() {
      this.$refs['stevedoreForm'].validate(valid => {
        if (valid) {
          if (this.obj && this.obj.id) {
            Stevedore.updateItem(this.obj.id, this.stevedore).then(res => {
              if (res.status === 200) {
                this.$message.success('Стивидор успешно обновлен')
                this.$emit('saved')
              }
            })
          } else {
            const organization_inn = this.userInfo.current.organization.inn

            Stevedore.postItem({ organization_inn, ...this.stevedore }).then(
              res => {
                if (res.status === 201) {
                  this.$message.success('Стивидор создан успешно')
                  this.$emit('saved')
                }
              },
            )
          }
        }
      })
    },
  },
}
</script>
